<template>
    <div class="demand">
        <div class="searchPart">
            <el-input v-model="nickname" placeholder="模型名称"></el-input>
            <el-button class="searchBtn" @click="search">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="reset">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>
        </div>
        <div class="tablePart">
            <div class="tableTool">
                <div class="toolLeft">
          <span>已选： <span class="num">{{ demandSelection.length }}</span></span>
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        @click="del('all')"
                        :disabled="demandSelection.length > 0 ? false: true"
                    >批量取消
                    </el-button
                    >
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                @selection-change="handleSelectionChange"
                class="tableContent"
            >
                <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="55"
                >
                </el-table-column>
                <el-table-column
                    prop="likeInfo.modelName"
                    label="模型名称"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <div class="modelImgsName">
                            <img :src="scope.row.likeInfo.imgUrl" alt="">
                            <a :href="$url.threeWeb+'/modelDetails?uuid='+scope.row.likeInfo.uuid" target="_blank"> <p>{{scope.row.likeInfo.modelName}}</p></a>
                        </div>

                    </template>
                </el-table-column>
                <el-table-column
                    prop="likeInfo.downNum"
                    label="下载"
                    header-align="center"
                    align="center"
                    width="183"
                    :formatter="((row,column)=>{return row.likeInfo.downNum == null ? 0 : row.likeInfo.downNum})"
                >
                </el-table-column>
                <el-table-column
                    prop="likeInfo.accessNum"
                    label="访问"
                    header-align="center"
                    align="center"
                    width="183"
                    :formatter="((row,column)=>{return row.likeInfo.accessNum == null ? 0 : row.likeInfo.accessNum})"
                >
                </el-table-column>
                <el-table-column
                    prop="likeInfo.price"
                    label="金额"
                    header-align="center"
                    align="center"
                    width="183"
                    :formatter="((row,column)=>{return row.likeInfo.price == null ? 0 : row.likeInfo.price})"
                >
                </el-table-column>
                <el-table-column
                    prop="state"
                    label="类型"
                    header-align="center"
                    align="center"
                    width="110"
                    :formatter="formatStatus"
                >
                </el-table-column>

                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230"
                >
                    <template slot-scope="scope">
                        <el-button @click="del(scope.row.uuid)"
                            type="text"
                            size="small"
                        >取消收藏
                        </el-button
                        >
                    </template>
                </el-table-column>
                 <template slot="empty">
                    <img src="../../assets/暂无收藏.jpg" alt="" style="width:200px">
                </template>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="pageNo"
                :page-size="pageSize"
                :total="total"
                class="pagination"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import {deleteCollects,getCollectListByMap} from '../../utils/interface';
    export default {
        data() {
            return {
                form: {},
                nickname: "",
                tableData: [
                ],
                pageNo: 0,
                pageSize: 10,
                total: 1000,
                demandSelection: [],
            };
        },
        computed: {
            ...mapState({}),
        },
        mounted() {
            this.getList()
        },
        methods: {
            // 清除检索条件
            reset() {
                this.nickname = "";
            },
            formatStatus: function (row, column) {
                let statusCn = '';
                if(row.likeInfo.attribute === 'FREE'){
                    statusCn='免费';
                }else if(row.likeInfo.attribute === 'PAY'){
                    statusCn='付费';
                }else if(row.likeInfo.attribute === 'BROWSE'){
                    statusCn='仅浏览';
                }else{
                    statusCn='已删除';
                }
                return statusCn;
            },
            // 分页
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getList()
            },
            // 获取列表
            getList() {
                let data = {
                    current: this.pageNo,
                    pageSize: this.pageSize,
                    likeType: 'MODEL',
                    nickname: this.nickname
                }
                getCollectListByMap(data).then((res) => {
                    this.tableData = res.list
                    this.total = res.total
                    this.pageNo = res.current
                })
            },
            // 复选框选中值
            handleSelectionChange(val) {
                this.demandSelection = val;
            },
            search() {
                this.pageNo = 1
                this.getList()
            },
            // 删除
            del(val){
                let ids = [];
                if(val === 'all'){
                    this.demandSelection.forEach((item)=>{
                        ids.push(item.uuid);
                    });
                } else {
                    ids.push(val)
                }
                console.log(ids);
                this.$confirm('确定要执行当前操作吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCollects(ids).then((res) => {
                        console.log(res);
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '操作成功！'
                            })
                            this.getList();
                        }
                    });
                }).catch(() => {})
            },
        },
    };
</script>

<style scoped lang="less">
    .demand {
        padding: 20px;

        .releaseBox {
            background: #fff;
            padding: 35px;
            padding-top: 0;
            box-sizing: border-box;

            .releaseBoxTop {
                margin-bottom: 15px;

                h4 {
                    font-size: 18px;
                    color: #157efa;
                    margin-bottom: 18px;
                }

                .releaseBoxTopInput {
                    font-size: 14px;
                    color: #262626;
                    align-items: center;
                    margin-bottom: 20px;

                    /deep/ .ql-toolbar.ql-snow {
                        display: none;
                    }

                    /deep/ .ql-toolbar.ql-snow + .ql-container.ql-snow {
                        border-top: 1px solid #ccc;
                    }

                    .releaseBoxTopInputBox {
                        flex-wrap: wrap;
                    }

                    input {
                        height: 30px;
                        background: #f5f5f5;
                        border-radius: 4px;
                        border: none;
                        padding-left: 8px;
                        box-sizing: border-box;
                    }

                    .input2 {
                        width: 161px;
                        // margin-left: 90px;
                    }

                    textarea {
                        width: 614px;
                        height: 206px;
                        background: #f5f5f5;
                        opacity: 1;
                        border-radius: 6px;
                        border: none;
                        padding: 8px;
                        box-sizing: border-box;
                    }

                    /deep/ .el-input--prefix .el-input__inner {
                        width: 161px;
                        height: 30px;
                        background: #f5f5f5;
                        border-radius: 4px;
                        border: none;
                        //   padding-left: 8px;
                        box-sizing: border-box;
                        //   margin-left: 25px;
                    }

                    // /deep/.el-input__prefix {
                    //   right: -132px;
                    //   left: 0;
                    // }
                    /deep/ .el-input__icon {
                        line-height: 30px;
                    }

                    .releaseBoxbotInputP {
                        width: 94px;
                        flex-shrink: 0;
                        white-space: nowrap;
                    }

                    .releaseBut {
                        background: #157efb;
                        color: #fff;
                    }

                    button {
                        width: 100px;
                        height: 30px;
                        background: #f5f5f5;
                        border-radius: 4px;
                        border: none;
                        margin-right: 20px;
                        color: #262626;
                        font-size: 14px;
                        cursor: pointer;
                    }
                }
            }
        }

        .searchPart {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
                margin-bottom: 22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom: 22px;
            }
        }

        .tablePart {
            .tableTool {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;

                .toolLeft {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.847);

                    .num {
                        color: #356fdf;
                    }

                    button {
                        padding: 0;
                        margin-left: 15px;
                        width: 80px;
                        height: 30px;
                        background: rgba(242, 244, 247, 1);
                        box-sizing: border-box;
                        border: 1px solid rgba(21, 126, 251, 1);
                        border-radius: 5px;
                        font-size: 12px;
                        color: #157efb;
                        line-height: 30px;
                        text-align: center;

                        &:hover {
                            background: #157efb;
                            box-sizing: border-box;
                            border: 1px solid #157efb;
                            color: #fff;
                        }
                    }
                }

                .toolRight {
                    button {
                        width: 83px;
                        height: 30px;
                        background: rgba(21, 126, 251, 1);
                        border: none;
                        border-radius: 15px;
                        font-size: 13px;
                        color: #fff;

                        i {
                            padding-right: 5px;
                        }

                        &:hover {
                            background: #61a2f0;
                        }
                    }
                }
            }

            .tableContent {
                min-height: 650px;

                .modelImgsName {
                    display: flex;
                    align-items: center;

                    img {
                        margin-right: 10px;
                        width: 120px !important;
                        height: 80px !important;
                    }
                }

                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }

                    /deep/ .el-table__row {
                        td:first-child {
                            border-right: none;

                            .cell {
                                padding-left: 15px;
                            }
                        }
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }
    }

    /deep/ .el-dialog__body {
        padding-top: 0;
    }

    .itemFlex {
        display: flex;
        align-items: center;
        margin-bottom: 14px;

        .name {
            margin-left: 10px;

            /deep/ p {
                margin: 0 !important;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/management/modelManagement.vue